import { render } from "./TiptapEditorPrototype.vue?vue&type=template&id=0b9079d0&scoped=true"
import script from "./TiptapEditorPrototype.vue?vue&type=script&lang=js"
export * from "./TiptapEditorPrototype.vue?vue&type=script&lang=js"

import "./TiptapEditorPrototype.vue?vue&type=style&index=0&id=0b9079d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9079d0"]])

export default __exports__